import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { IconComponent, IconName, RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-churn-flow-insight-card',
  templateUrl: './churn-flow-insight-card.component.html',
  styleUrls: ['./churn-flow-insight-card.component.less'],
  imports: [IconComponent, RtTooltip],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChurnFlowInsightCardComponent {
  public iconName = input.required<IconName>();
  public value = input.required<string>();
  public title = input<string>();
  public label = input.required<string>();
  public tooltip = input<string>();
}
